<template>
    <div>
        <el-container>
<!--            :style="{'text-align':'left','display':'flex'}"-->
            <el-header >
                <el-row :gutter="24" type="flex">
                    <el-col :span="6"><div class="grid-content bg-purple">
                        <el-input
                                ref="word"
                                id="checkInput"
                                :style="{'width':'250px'}"
                                @click="getWordds"
                                placeholder="请输入内容"
                                v-model="searchWord"
                                clearable>
                            <el-button @click="getWordds"  type="text"  slot="suffix" icon="el-icon-search" ></el-button>
                            <!--                        <i :style="{'cursor':'pointer'}" slot="suffix" class="el-input__icon el-icon-search" @click="getWordds"></i>-->
                        </el-input>
                    </div></el-col>
                    <el-col :span="16" hidden-xs-only justify="center"><div class="grid-content bg-purple">
                        <word-tool-button-p></word-tool-button-p>
                    </div></el-col>
                    <el-col :span="2" justify="end"><div class="grid-content bg-purple">
                        <user-login :style="{'right':'0px','flex':'1','position':'relative'}"></user-login>
                    </div></el-col>
                </el-row>

            </el-header>
<!--           :style="{'display':'flex'}"&ndash;&gt;-->
<!--            flex: 1;-->
            <el-main >
                <word-detils v-if="$store.getters.isShow('查词')"></word-detils>
                <div v-if="$store.getters.isShow('背词')">
                    <word-card-list ref="wordCard"></word-card-list>
                    <div style="width: 450px;">
                        <el-input ref="inputWord" placeholder="请拼写单词" v-model="inputWord" class="input-with-select" @change="nextPractise">

                            <el-select v-model="reviewList"  default-first-option  slot="prepend" placeholder="请选择" style="width: 100px;" @change="aaa(reviewList)" clearable>
<!--                            <el-select v-model="value" placeholder="请选择">-->
                                <el-option
                                        v-for="item in this.$store.state.a.allPlanWordLIst"
                                        :key="item.startdate"
                                        :label="item.startdate"
                                        :value="item.startdate">
                                </el-option>
<!--                                <el-option label="ONE" value="2"></el-option>&ndash;&gt;-->
<!--                                <el-option :label="item.startdate" :value="item.startdate" v-for="(item,index) in this.$store.state.a.allPlanWordLIst"></el-option>-->
<!--                                <el-option label="ONE" value="2"></el-option>-->
<!--                                <el-option label="TWO" value="3"></el-option>-->
<!--                                <el-option label="THREE" value="4"></el-option>-->
                            </el-select>

                            <el-button slot="append" icon="el-icon-search"></el-button>
                            <el-button slot="append" icon="el-icon-refresh" @click="refreshWord"></el-button>

                        </el-input>
                        <el-switch
                                style="display: block"
                                v-model="$store.state.a.wordListSwitch"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                active-text="默"
                                inactive-text="背">
                        </el-switch>
                    </div>
                </div>


<!--                            <div>{{$store.state.a.showModuleList}}</div>-->
<!--                            <div>{{$store.getters.isShow('查词')}}</div>-->

            </el-main>
        </el-container>
        <div>
<!--            <word-plan-list></word-plan-list>-->
            <word-table-list-p v-if="$store.getters.isShow('列表')"></word-table-list-p>
        </div>
    </div>
</template>

<script>
    import WordDetils from "./childComps/WordDetils";
    import WordCardList from "./childComps/WordCardList";
    import WordToolButtonP from "./childComps/toolChildComps/WordToolButtonP";
    import WordPlanList from "./childComps/WordPlanList";
    import UserLogin from "./childComps/UserLogin";
    import WordTableListP from "./childComps/WordTableListP";


    export default {
        name: "LearnEnglishP",
        components:{
            WordDetils,
            WordCardList,
            WordToolButtonP,
            WordPlanList,
            UserLogin,
            WordTableListP,
        },

        data() {
            return {
                reviewList:[
                    'list1',
                    'list2',
                    'list3',
                    'list4',

                ],
                inputWord:'',
                searchWord:'',
                checkWord:'',
                count: 0,
                input: '',
                lastInputWord:'',
                listSwitch:true,

            }
        },
        mounted() {
            this.$store.dispatch('requireWord','bull'),
            this.$store.dispatch('requireRecoverWord').then(res=>{
                this.$notify({
                    title: '以下单词已经回收，请再次学习',
                    message: res,
                    dangerouslyUseHTMLString:true,
                    type: 'warning'
                });
            });
            this.$bus.$on('newWordLoad',this.aaa);
        },
        methods:{
            aaa(aa){
                this.$store.dispatch('requireDateWord',aa);
                // alert(aa)
            },
            getWordds(){
                // alert("111")
                // this.searchWord =this.$refs.word.value;
                this.$store.dispatch('requireWord',this.searchWord)
            },
            load () {
                this.count += 2
            },
            nextPractise(){

                this.$store.dispatch('checkWord', this.$refs.inputWord.value).then(res => {
                    // this.$store.commit('setIsBackCardWordItem');
                    this.$message({
                        message: res + '    已成功打卡!',
                        type: 'success',
                        duration:5000
                    });


                }).catch(res=>{
                    this.$refs.wordCard.nextword();
                    // alert(this.$store.state.a.wordListSwitch);
                    if(this.$store.state.a.wordListSwitch){
                        this.$message({
                            message: res + '     很遗憾！',
                            type: 'error',
                            duration:10000
                        });
                    }

                });
                this.inputWord='';


                // alert("777");
                // alert(this.$store.state.a.isBackCardWordItem);
                // if(this.$store.state.a.isBackCardWordItem){
                //     alert("888")
                //     this.$refs.wordCard.settword(this.$store.state.a.backCardWordItemNum);
                //     this.$store.commit('setIsBackCardWordItem');
                // }


            },
            refreshWord(){
                this.$refs.wordCard.settword(0);
                this.$store.commit('refreshInputList');
            }
        }

    }
</script>

<style scoped>
    .el-header, .el-footer {
        background-color: #B3C0D1;
        color: #333;
        text-align: center;
        line-height: 60px;
    }

    .el-aside {
        background-color: #D3DCE6;
        color: #333;
        text-align: center;
        line-height: 200px;
    }

    .el-main {
        background-color: #E9EEF3;
        color: #333;
        text-align: left;
        /*line-height: 160px;*/
    }
    /*-------------------------------------------------------------*/

    .divLeft{
        /*left: 0px;*/
        /*position: relative;*/
        text-align: left;
        /*display: flex;*/
    }

</style>